module.exports = __webpack_public_path__ + "assets/img/ic_search_sm.460af5b6.svg";